export const WARNING = 'warning';
export const ERROR = 'error';
export const SUCCESS = 'success';
export const DEFAULT = 'default';
